import React from 'react';
import ReactDOM from 'react-dom';

import IncidentTemplateListItem from './incident_template_list_item';
import EditFieldModal from './../../edit_field_modal';

const ClosedState = 'fa fa-plus-square-o';
const OpenState = 'fa fa-minus-square-o';

class IncidentTemplateListGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { groupShow: OpenState };
  }

  toggleDropdown = () => {
    const { groupShow } = this.state;
    this.setState({
      groupShow: groupShow === ClosedState ? OpenState : ClosedState,
    });
  };

  showTemplateGroups = () => {
    const { group, pageParam } = this.props;

    return (
      <div>
        {group.templates.map(template => {
          return (
            <div className="template-sub-item" key={template.id}>
              <IncidentTemplateListItem
                template={template}
                pageParam={pageParam}
              />
            </div>
          );
        })}
      </div>
    );
  };

  triggerEditModal = event => {
    event.preventDefault();
    event.stopPropagation();
    $(ReactDOM.findDOMNode(this))
      .find('#modal-confirmation-edit-incident-template-group-name')
      .modal();
  };

  handleDelete = () => {
    const { group, pageParam } = this.props;
    if (
      window.confirm(
        'Are you sure you want to delete this template group? Templates in this group won\'t be deleted, but will become "ungrouped" templates.',
      )
    ) {
      $.ajax({
        type: 'DELETE',
        url: Routes.page_incident_template_group_path(pageParam, group.param),
        dataType: 'JSON',
        success: (data, textStatus, xhr) => {
          window.location.reload(true);
        },
        error: (xhr, textStatus) => {
          HRB.utils.basicFailAndReload('deleting an incident template group');
        },
      });
    }
  };

  renderTemplateGroupHeading = () => {
    return (
      <>
        <div className="template-meta">
          <strong>{this.props.group.name}</strong>
        </div>
        <a href="#" onClick={this.triggerEditModal}>
          Edit
        </a>
        <a href="#" className="template-delete" onClick={this.handleDelete}>
          Delete
        </a>
      </>
    );
  };

  renderAdg3TemplateGroupHeading = () => {
    return (
      <div className="template-group-heading">
        <div className="template-meta">
          <strong>{this.props.group.name}</strong>
        </div>
        <div className="template-group-heading-actions">
          <a href="#" className="template-delete" onClick={this.handleDelete}>
            Delete
          </a>
          <a href="#" onClick={this.triggerEditModal}>
            Edit
          </a>
        </div>
      </div>
    );
  };

  render() {
    const { group, pageParam } = this.props;
    const { groupShow } = this.state;
    return (
      <div className="table-row">
        <i className={groupShow} onClick={this.toggleDropdown} />

        {this.renderAdg3TemplateGroupHeading()}

        {groupShow === OpenState ? this.showTemplateGroups() : null}

        <EditFieldModal
          id="edit-incident-template-group-name"
          title={`Edit ${group.name}`}
          putUrl={Routes.page_update_group_name_path(pageParam)}
          owningEntityParam={group.param}
          label="Group name"
          value={group.name}
          placeholder="Group name"
          paramName="group_name"
          submit_text="Save"
        />
      </div>
    );
  }
}

export default IncidentTemplateListGroup;
